import { FunctionComponent, useState } from 'react';

interface InfoCardProps {
  readonly term: string;
  readonly title: string;
  readonly body: string;
}

const InfoCard: FunctionComponent<InfoCardProps> = ({ term, title, body }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleToggle = (): void => {
    setIsOpen((prev) => !prev);
  };

  const handleClose = (e: React.MouseEvent): void => {
    e.stopPropagation();
    setIsOpen(false);
  };

  return (
    <span className="inline">
      <span
        className="inline-flex items-center gap-0.5 cursor-pointer"
        onClick={handleToggle}
      >
        <span className="text-primary font-medium border-b border-dashed border-primary">
          {term}
        </span>
        <span className="w-[14px] h-[14px] rounded-full bg-primary text-white text-[9px] font-medium inline-flex items-center justify-center align-middle ml-0.5 flex-shrink-0">
          {isOpen ? 'x' : '+'}
        </span>
      </span>

      {isOpen && (
        <span className="block mt-2 bg-primary-light rounded-lg px-3 py-3">
          <span
            className="float-right text-xs text-primary cursor-pointer ml-2"
            onClick={handleClose}
          >
            close x
          </span>
          <span className="block text-xs font-medium text-primary-dark mb-1">
            {title}
          </span>
          <span className="block text-xs text-primary leading-relaxed">
            {body}
          </span>
        </span>
      )}
    </span>
  );
};

export default InfoCard;

